<div [formGroup]="parentForm">
  <div formArrayName="partnerPermissions">
    <div [formGroup]="partnerFormGroup" class="fx-layout-row-wrap fx-layout-xs-column">
      <mat-form-field class="fx-flex-200px">
        <mat-label>Affiliation(s)</mat-label>
        <mat-select formControlName="affiliationType">
          <mat-option>Affiliation(s)</mat-option>
          @if (selectedPartner) {
            <mat-option
              [value]="selectedPartner.key">
              {{ selectedPartner.value }}
            </mat-option>
          }
          @for (type of (affiliationTypes$ | async); track type) {
            <mat-option
              [value]="type.key">
              {{ type.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (memberIdCtrl) {
        <mat-form-field [formGroup]="partnerAffiliationFormGroup" class="input-form-field fx-flex-20">
          <mat-label>Member ID</mat-label>
          <input matInput type="text" formControlName="memberId" required />
          @if (memberIdCtrl.hasError('required')) {
            <mat-error>
              This is a required field
            </mat-error>
          }
          @if (memberIdCtrl.hasError('incorrect')) {
            <mat-error>
              Member ID is not valid.
            </mat-error>
          }
        </mat-form-field>
      }
      @if (gnjUUIDCtrl) {
        <mat-form-field [formGroup]="partnerAffiliationFormGroup" class="input-form-field fx-flex-20">
          <mat-label>Company email or UUID</mat-label>
          <input matInput type="text" formControlName="gemAndJewelId" required />
          @if (gnjUUIDCtrl.hasError('required')) {
            <mat-error>
              This is a required field
            </mat-error>
          }
        </mat-form-field>
      }
      <mat-form-field [formGroup]="partnerAffiliationFormGroup" class="fx-flex-15">
        <mat-label>Start Date</mat-label>
        <input matInput formControlName="startDate" [matDatepicker]="startDate">
        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field [formGroup]="partnerAffiliationFormGroup" class="fx-flex-15">
        <mat-label>End Date</mat-label>
        <input [errorStateMatcher]="matcher" matInput formControlName="endDate" type="text" [matDatepicker]="endDate">
        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate></mat-datepicker>
        @if (partnerAffiliationFormGroup.errors?.endDateLessThanStartDate) {
          <mat-error>End date cannot be earlier than start date</mat-error>
        }
      </mat-form-field>
      @if (statusCtrl) {
        <div [formGroup]="partnerAffiliationFormGroup" class="mt-2 fx-flex-76px fx-layout-column fx-align-center-center fx-align-xs-start-start">
          <mat-checkbox matInput formControlName="status">Is Active</mat-checkbox>
        </div>
      }
    </div>
  </div>
</div>